interface LogoProps {
  className?: string;
}

export function MSCIAllWorldLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M25,2.8C12.7,2.8,2.8,12.7,2.8,25c0,12.3,9.9,22.2,22.2,22.2s22.2-9.9,22.2-22.2c0-12.2-9.9-22.2-22.2-22.2M42.1,14.9c-2.4.4-4.8.8-7.2,1-.9-4.2-2.4-7.7-4.3-10,4.8,1.4,8.9,4.6,11.5,8.9h0ZM33.5,25c0,2.1-.1,4.2-.4,6.3-5.4-.4-10.7-.4-16.1,0-.6-4.2-.6-8.6,0-12.8,2.6.2,5.3.3,7.9.3s5.4-.1,8.1-.3c.3,2.2.5,4.4.5,6.6M25,5.1c3,0,6.1,4.2,7.6,11-5,.4-10.1.4-15.2,0,1.5-6.8,4.6-11,7.6-11M19.4,5.9c-1.9,2.3-3.4,5.8-4.3,10-2.4-.2-4.8-.6-7.2-1,2.6-4.3,6.7-7.5,11.5-9M5.1,25c0-2.7.6-5.4,1.7-7.9,2.6.5,5.3.9,7.9,1.2-.6,4.4-.7,8.8,0,13.2-2.7.3-5.3.6-8,1.1-1-2.4-1.5-5-1.5-7.6M7.7,34.8c2.4-.4,4.9-.8,7.3-1,.9,4.3,2.4,7.9,4.3,10.3-4.9-1.5-9.1-4.8-11.7-9.3h0ZM25,44.9c-3,0-6.2-4.3-7.6-11.3,5.1-.4,10.2-.4,15.3,0-1.5,7-4.6,11.3-7.6,11.3M30.6,44c1.9-2.4,3.4-6,4.3-10.3,2.5.2,4.9.6,7.3,1-2.5,4.5-6.7,7.8-11.6,9.3h0ZM35.4,31.5c.6-4.4.6-8.9,0-13.2,2.6-.3,5.3-.7,7.9-1.2,2.2,5,2.2,10.6.2,15.5-2.7-.5-5.3-.9-8-1.1h0Z" 
      />
    </svg>
  );
}